//import { useState } from "react";
import React, { Fragment, useContext, useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  FormControl,
  Button,
} from "@mui/material";
import { Box } from "@mui/system";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import { toast } from "react-toastify";
import "./style.css";
import InputForm from "./InputForm";
import InputFormBody from "./InputForm_BodyOnly";
import InputHeader from "./InputHeader";
import { closestIndexTo } from "date-fns";

const Candidate_form = (params: any) => {
  const [showDelete, setShowDelete] = useState(true);
  const [children, setChildren] = useState(params.childrenData);

  const isChildSection =
    params.title === "Child(ren)" ||
    params.title === "Domestic Partner's Child(ren)";

  const isFamilyTier =
    Array.isArray(params.selectedCoverages) &&
    params.selectedCoverages.some((c: any) => parseInt(c.value) === 4);

  const addChild = () => {
    setChildren([...children, 1]);
  };

  const handleChildRowDelete = (index: number, titleStr: string) => {
    const ind = params.formData.findIndex((x: any) => x.title == titleStr);
    if (ind >= 0) {
      params.formData.splice(ind, 1);
      if (params.setFormData) {
        params.setFormData([...params.formData]);
      }
    }
    setChildren((prev: any[]) => {
      const next = prev.filter((_: any, i: number) => i !== index);
      // Snackbar when last child removed and Family tier is not selected
      if (next.length === 0 && !isFamilyTier) {
        toast.error("Please add at least one child dependent before continuing.", {
          toastId: "dependent-required-child",
        });
      }
      return next;
    });
    setShowDelete(true);
  };

  return (
    <Box sx={{ margin: "20px 0px", width: "100%" }} className="candidate-form-section">
      <Grid container xs={12} className="c-form-title">
        <Typography variant="h5">{params.title}</Typography>
        {isChildSection ? (
          <Button
            className="add-styling"
            variant="contained"
            disabled={false}
            onClick={() => {
              addChild();
              setShowDelete(true);
            }}
          >
            Add Child
          </Button>
        ) : null}
      </Grid>

      <>
        <InputHeader title={params.title} />
        {isChildSection ? (
          children.map((e: any, index: any) => (
            <InputFormBody
              key={`${params.title}_${index}`}
              title={params.title + "_" + index}
              setShowDelete={setShowDelete}
              showDelete={showDelete}
              formData={params.formData}
              setFormData={params.setFormData}
              cIndex={index}
              selectedCoverages={params.selectedCoverages}
              dependentData={params.dependentData}
              action={params.action}
              isTierChanged={params.isTierChanged}
              isSubmitted={params.isSubmitted}
              setFormError={params.setFormError}
              onChildDelete={handleChildRowDelete}
            />
          ))
        ) : (
          <InputFormBody
            title={params.title}
            setShowDelete={setShowDelete}
            showDelete={showDelete}
            formData={params.formData}
            setFormData={params.setFormData}
            selectedCoverages={params.selectedCoverages}
            dependentData={params.dependentData}
            action={params.action}
            isTierChanged={params.isTierChanged}
            isSubmitted={params.isSubmitted}
            setFormError={params.setFormError}
          />
        )}
      </>
    </Box>
  );
};
export default Candidate_form;
